module.exports = __webpack_public_path__ + "img/get-tip@3x.1c446390.png";